(function($) {
    function ScrollToTopButton(element) {
        var $scrollToTopButton = $(element);
        var $window = $(window);
        var scrollWithoutButton = getScrollWithoutButtonLength();

        $window.scroll(function() {
            if ($window.scrollTop() > scrollWithoutButton) {
                $scrollToTopButton.addClass('active');
            } else {
                $scrollToTopButton.removeClass('active');
            }
        });

        $window.on('resize', function() {
            scrollWithoutButton = getScrollWithoutButtonLength();
        });

        $scrollToTopButton.click(function() {
            $('html, body').animate({scrollTop : 0}, 800);
            return false;
        });

        function getScrollWithoutButtonLength() {
            // потому что есть $max-width-phone-vertical: 414px;
            var fullScreenCount = $window.width() > 414 ? 2 : 3;
            return $window.height() * fullScreenCount;
        };
    }

    $.fn.ScrollToTopButton = function() {
        this.each(function () {
            new ScrollToTopButton(this);
        });
    }
})(jQuery);